export default {
  autoAcceptColor: 'var(--omalaina-bright-orange)',
  autoAcceptBg: 'var(--omaliana-light-orange)',
  disclaimerMargin: '-0.5rem 1.5rem 3rem 3rem',
};
